<figure class="user-avatar-img bg-primary">
    @if (imageUrl) {
        <img [attr.src]="imageUrl | safe: 'resourceUrl'"
             [attr.alt]="'aria.userAvatar' | translate">
    } @else {
        <div class="user-avatar-pictogram">{{ label | slice:0:1 }}</div>
    }
</figure>

@if (!hideLabel) {
    <div class="user-avatar-text">
        {{ label }}
    </div>
}

